import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface UpdateCompanyFilePayload {
  name?: string;
  description?: string;
  sensitive?: boolean;
}

async function updateCompanyFile(
  companyId: string,
  fileId: string,
  payload: UpdateCompanyFilePayload,
  auth: Authentication | null
): Promise<void> {
  try {
    if (!auth) throw new UpdateCompanyFileFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const response = await HttpClient.patch(
      `/backoffice/companies/${companyId}/files/${fileId}`,
      payload,
      auth.token
    );

    if (!response.success) throw new UpdateCompanyFileFailure(response.message, response.code);
  } catch (e) {
    if (e instanceof UpdateCompanyFileFailure) throw e;
    const errMessage = e instanceof Error ? e.message : 'Une erreur inattendue s’est produite.';
    throw new UpdateCompanyFileFailure(
      errMessage.trim() || 'Erreur réseau ou serveur. Réessayez plus tard.',
      'request-failed'
    );
  }
}

export class UpdateCompanyFileFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default updateCompanyFile;
